import React from 'react';
import download from '../../../../assets/Cards/download.svg';
import downloadHsb from '../../../../assets/Cards/Horizon/download.svg';
import { isHorizon } from '../../../../utils/brandHelper';

const DownloadPolicy = props => {
  const downloadIcon = isHorizon ? downloadHsb : download;

  return (
       <div className={props.class} onClick={()=> {
          window.open(`${process.env.REACT_APP_PDF_URL + props.policy_pdf_path}`, '_blank').focus();
       }}>
            <img src={downloadIcon} />
            <div className="infoText download">Download policy summary</div>
       </div>
  );
};

export default DownloadPolicy;
